import { render, staticRenderFns } from "./OneColumnContent.vue?vue&type=template&id=e6721500&"
import script from "./OneColumnContent.vue?vue&type=script&lang=js&"
export * from "./OneColumnContent.vue?vue&type=script&lang=js&"
import style0 from "./OneColumnContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports